import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Redirect } from 'react-router-dom';
import axios from "../../server/interceptors";
import {
    DEFAULT_LANGUAGE, apiGradeModifyUrl, apiGradeUrl
} from '../../config';
import {Button, Container} from 'react-bootstrap';
import './edit-level-page-style.css';
import LevelDisplayView from "../../components/levelDisplayView";
import SessionManager from "../../utils/authHandling/session-manager";

class EditLevelPage extends Component {

    constructor(props){
        super(props);
        this.state={
            loading: false,
            id: sessionStorage.lastLevelId,
            code: "",
            name: "",
            redirect: false,
        };
        this.saveData = this.saveData.bind(this);
        this.onChange = this.onChange.bind(this);
        this.redirect = this.redirect.bind(this);
    }

    onChange(field, value){
        //Trick to add to state from multiple inputs with same function
        this.setState({[field]: value});
    }

    componentDidMount() {
        this.onDataCall();
    }

    onDataCall(){

        axios.get(`${apiGradeUrl}/${this.state.id}`, {
            headers: {
                'Content-Type': 'application/json',                
            }}).then((response)=>{
            this.setState({
                code: response.data[0].Code,
                name: response.data[0].Name,
            });

        }).catch(error => {
            console.log(error.response.data.Messages);
        });
    }

    saveData(){

        // Validate
        if(this.state.code === ""){
            alert("Error: Code is required./El código es requerido.");
            return;
        }

        if(this.state.name === "" || this.state.name === ""){
            alert("Error: The name is required./El nombre  es requerido.");
            return;
        }

        this.setState({loading: true}, ()=>{
            // Call the API to insert
            let params = {
                Id: this.state.id,
                Code: this.state.code,
                Name: this.state.name,
            };

            axios.post(apiGradeModifyUrl, params,{
                headers: {
                    'Content-Type': 'application/json',                    
                }}).then((response)=>{

                    if(response.status === 200)
                    {
                        alert("Level successfully saved./Nivel guardado satisfactoriamente.");
                    }
                    else
                    {
                        alert("Validate the fields. If the error continues, contact the administrator./Valide los campos. Si el error persiste, contacte al administrador.");
                    }
                this.setState({loading: false});
            }).catch(error => {
                alert(`Error:  ${error}`);
                this.setState({loading: false});
            });
        });
    }


    redirect(){
        this.setState({redirect: true})
    }

    render(){

        if (this.state.redirect) {
            return <Redirect to='/view-levels' />
        }
        return(
            <Container fluid className="card-alt">
              <div>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                            <h2><FormattedMessage id="lev-level"/></h2>
                            {this.state.loading ?
                                <div>
                                    <Button disabled variant="success">
                                        <FormattedMessage id="am-save"/>
                                    </Button>
                                </div>:
                                <div>
                                    <Button variant="success" onClick={this.saveData}>
                                        <FormattedMessage id="am-save"/>
                                    </Button>
                                </div>
                            }
                        </div>

                        <LevelDisplayView
                            isCreation={false}
                            language={this.props.language}
                            additionalMaterialContent={this.state}
                            onChange={this.onChange}
                        />
                    </div>
            </Container>
        );
    }
}

export default EditLevelPage;